import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import Translator from '../core/i18n';
import { ApiTypes } from '../models/enums/ApiTypes';
import { ActivityTypeEnums } from '../models/enums/ActivityType';
import { enrollmentStatus } from '../models/enums/enrollmentStatus';

const _logger = Log.create('Background-Service');
const T = Translator.create();
let _apiClient: ApiClient;

export class BackgroundService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestActivityReportAsync(params: any) {
        const requestUrl = `api/background/activityReportDownload?activityId=${params.activityId}&classId=${params.classId}&isDetailed=${params.isDetailed}&virtualClassReportType=${params.virtualClassReportType}`;

        return _apiClient
            .RequestAsync('GET', requestUrl, null, '', false, ApiTypes.Background)
            .then((responseData: any) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestAssignmentFilesDownloadAsync(activityId: string, classId: string) {
        const requestUrl = `api/background/assignmentallfiles?activityId=${activityId}&classId=${classId}`;
        return _apiClient
            .RequestAsync('GET', requestUrl, null, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestPlagiarismControlAsync(activityId: string, classId: string) {
        const requestUrl = `api/background/requestPlagiarismControl?activityId=${activityId}&classId=${classId}`;
        return _apiClient
            .RequestAsync('GET', requestUrl, null, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestPlagiarismReportUrlAsync(plagiarismRemoteId: string) {
        const requestUrl = `api/background/getPlagiarismReportUrl?plagiarismRemoteId=${plagiarismRemoteId}`;
        return _apiClient
            .RequestAsync('GET', requestUrl, null, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestDownloadEnrollmentDataAsync(params: {
        selectedCourses: string[];
        selectedClasses: string[];
        selectedUsers: string[];
        selectedActivities: string[];
        selectedActivityTypes: ActivityTypeEnums[];
        selectedStatuses: enrollmentStatus[];
        beginDate?: string | Date;
        endDate?: string | Date;
        colOrder?: string;
        rowOrder?: string;
        cols?: string[];
        rows?: string[];
        culture?: string;
    }) {
        return _apiClient
            .RequestAsync('POST', 'api/background/enrollmentReportDownload', params, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestQuestionBankExcelDownloadAsync(params: any) {
        return _apiClient
            .RequestAsync('POST', 'api/background/downloadQuestionBank', params, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestDownloadAttendaceAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/background/downloadattendancereport', params, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestGetAnnouncementEmailAsync(announcementId: string) {
        const requestUrl = `api/background/sendAnnouncementMail?announcementId=${announcementId}`;

        return _apiClient
            .RequestAsync('GET', requestUrl, null, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestGetMessageEmailAsync(MessageId: string, OriginMessageId: string) {
        const requestUrl = `api/background/sendMessageEmail?MessageId=${MessageId}&OriginMessageId=${OriginMessageId}`;

        return _apiClient
            .RequestAsync('GET', requestUrl, null, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            })
            .then((result: any) => {
                return result;
            })
            .catch(response => {
                return response;
            });
    }

    public async RequestExamPopulatePurgeAsync(ExamSessionId: string) {
        return _apiClient.RequestAsync('POST', 'api/background/exampopulatepurge', ExamSessionId, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestMessageToIncompleters(params: { activityId: string, hostAddress: string }) {
        return _apiClient.RequestAsync('POST', 'api/background/messageToIncompleters', params, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestDownloadStudentListReportAsync(ClassId: string, CourseId: string) {
        const params = {
            ClassId: ClassId,
            CourseId: CourseId
        }
        return _apiClient.RequestAsync('POST', 'api/background/downloadstudentlistreport', params, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestUploadMultiQuestionsAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/background/uploadmultiquestionexcel', params, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestSaveUploadedQuestionsAsync(trackingGuidS: string) {
        
        return _apiClient.RequestAsync('POST', 'api/background/saveuploadedquestions', trackingGuidS, '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async SendTwoFactorVerificationMail(target: string, isEmailAdding: boolean) {
        const parsedUrl = new URL(window.location.href);
        if ((parsedUrl.port === '' || parsedUrl.port === null) && parsedUrl.protocol === 'http:') {
            parsedUrl.port = '3000';
        }
        return _apiClient.RequestAsync('POST', 'api/background/sendtwofactorverificationmail', {
            Target: target,
            IsEmailAdding: isEmailAdding,
            Address: parsedUrl.hostname,
            Port: parsedUrl.port,
        } , '', false, ApiTypes.Background)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }
}
